
export function postForm(url: string, data: FormData, onSuccess: Function, onError: Function) {
    fetch(url, {method: 'POST', body: data})
        .then(r => {
            if(r.status >= 200 && r.status < 300)
                onSuccess()
            else
                onError()
            })
}